// extracted by mini-css-extract-plugin
module.exports = {"notecardEditor":"NotecardEditor_notecardEditor__NGu4q"};